// extracted by mini-css-extract-plugin
export default {"sign_in":"ConfirmEmail_sign_in__WJxRC"};